import {
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
  getDocs,
  collection,
  deleteDoc,
  updateDoc,
} from 'firebase/firestore';
import { getStorage, ref, deleteObject } from 'firebase/storage';
import { COLLECTIONS, blogStatus } from '../configs/Constants';
import { auth, db } from '../configs/Firebase';

export const createBlog = async ({
  title,
  content,
  status,
  createdAt,
  description,
  coverImage,
}) => {
  const newDoc = doc(db, COLLECTIONS.BLOGS, title.toLowerCase().trim().split(' ').join('-'));
  const docSnap = await getDoc(newDoc);
  if (docSnap.exists()) {
    throw new Error('Blog with similar title already exists.');
  }
  await setDoc(newDoc, {
    title,
    content,
    status,
    description,
    authorId: auth.currentUser.uid,
    createdAt: createdAt || serverTimestamp(),
    coverImage: coverImage || '',
  });
};

export const updateBlog = async (
  documentId,
  { title, content, status, description, coverImage }
) => {
  // delete old
  const docRef = doc(db, COLLECTIONS.BLOGS, documentId);
  const docSnap = await getDoc(docRef);

  if (documentId === title.toLowerCase().trim().split(' ').join('-')) {
    if (
      docSnap.exists() &&
      docSnap?.data()?.coverImage &&
      docSnap?.data()?.coverImage !== coverImage
    ) {
      const storage = getStorage();
      const storageRef = ref(storage, docSnap?.data()?.coverImage);
      await deleteObject(storageRef);
    }
    updateDoc(docRef, { title, content, status, description, coverImage });
  } else {
    const createdAt = docSnap?.data()?.createdAt || null;
    // delete old
    await deleteDoc(docRef);
    if (
      docSnap.exists() &&
      docSnap?.data()?.coverImage &&
      docSnap?.data()?.coverImage !== coverImage
    ) {
      const storage = getStorage();
      const storageRef = ref(storage, docSnap?.data()?.coverImage);
      await deleteObject(storageRef);
    }
    // create new
    await createBlog({ title, content, status, createdAt, description, coverImage });
  }
};

export const deleteBlogById = async (documentId) => {
  // delete old
  const docRef = doc(db, COLLECTIONS.BLOGS, documentId);
  const docSnap = await getDoc(docRef);

  // Delete the image from Firebase Storage if a cover image path is provided
  if (docSnap.exists() && docSnap?.data()?.coverImage) {
    const storage = getStorage();
    const storageRef = ref(storage, docSnap?.data()?.coverImage);
    await deleteObject(storageRef);
  }

  await deleteDoc(doc(db, COLLECTIONS.BLOGS, documentId));
};

export const viewBlogById = async (documentId) => {
  const docRef = doc(db, COLLECTIONS.BLOGS, documentId);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    const mainData = docSnap.data();
    return mainData;
  }
  throw new Error('No blog exists.');
};

export const getBlogs = async () => {
  const querySnapshot = await getDocs(collection(db, COLLECTIONS.BLOGS));
  const rows = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < querySnapshot.docs.length; i++) {
    const d = querySnapshot.docs[i];

    const tempData = d.data();

    if (tempData.authorId) {
      const aDocRef = doc(db, COLLECTIONS.USERS, tempData.authorId);
      // eslint-disable-next-line no-await-in-loop
      const aDocSnap = await getDoc(aDocRef);
      if (aDocSnap.exists) {
        tempData.creator = aDocSnap.data()?.name || 'N/A';
      }
    }

    rows.push({
      id: d.id,
      ...tempData,
      status: Number(tempData?.status) || blogStatus.DRAFT,
    });
  }

  return rows;
};
